
<div>
	<v-container align="center" justify="center" class="pt-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"
					><h1>{{ getLabel('companyOperations', 'Practice Operations') }}</h1></v-list-item-title
				>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-container class="pt-0 mt-0 mb-0">
		<v-form ref="practiceOperationsForm" v-model="valid" lazy-validation class="pl-4 pr-5">
			<v-card-text align="center" justify="center" class="justify-center text-center">
				<v-row
					><v-col>
						<v-list-item-title align="center" justify="justify" class="pb-1 text-wrap"><h2>Open hours</h2></v-list-item-title>
					</v-col></v-row
				>

				<v-row
					><v-col>
						<v-list-item-title align="left" justify="left" class="pb-1 text-wrap"><h3>Weekdays</h3></v-list-item-title>
					</v-col></v-row
				>

				<v-row align="baseline" justify="center">
					<v-col>
						<time-picker-dialog initial="08:00" label="Start time" @input="OnWeekdayStartTimeInput"></time-picker-dialog>
					</v-col>
					<v-col cols="1"
						><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
					>
					<v-col>
						<time-picker-dialog initial="18:00" label="End time" @input="OnWeekdayEndTimeInput"></time-picker-dialog>
					</v-col>
				</v-row>

				<v-row
					><v-col>
						<v-list-item-title align="left" justify="left" class="pb-1 pt-2 text-wrap"><h3>Saturdays</h3></v-list-item-title>
					</v-col></v-row
				>

				<v-row align="baseline" justify="center">
					<v-col>
						<time-picker-dialog initial="09:00" label="Start time" @input="OnSaturdayStartTimeInput"></time-picker-dialog>
					</v-col>
					<v-col cols="1"
						><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
					>
					<v-col>
						<time-picker-dialog initial="13:00" label="End time" @input="OnSaturdayEndTimeInput"></time-picker-dialog>
					</v-col>
				</v-row>

				<v-row
					><v-col class="pb-0 mb-0">
						<v-checkbox v-model="openSunday" :value="openSundayComputed"
							><template #label
								><div>
									<v-list-item-title align="center" justify="center" class="text-wrap"><h3>We are open on Sundays</h3></v-list-item-title>
								</div></template
							></v-checkbox
						>
					</v-col></v-row
				>
				<v-row v-show="openSunday" align="baseline" justify="center">
					<v-col class="pt-0">
						<time-picker-dialog initial="09:00" label="Start time" @input="OnSundayStartTimeInput"></time-picker-dialog>
					</v-col>
					<v-col cols="1"
						><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
					>
					<v-col>
						<time-picker-dialog initial="13:00" label="End time" @input="OnSundayEndTimeInput"></time-picker-dialog>
					</v-col>
				</v-row>

				<v-row
					><v-col class="pb-0 mb-0">
						<v-checkbox v-model="openHoliday"
							><template #label
								><div>
									<v-list-item-title align="center" justify="center" class="text-wrap"><h3>We are open on Public Holidays</h3></v-list-item-title>
								</div></template
							></v-checkbox
						>
					</v-col></v-row
				>
				<v-row v-show="openHoliday" align="baseline" justify="center">
					<v-col class="pt-0">
						<time-picker-dialog initial="09:00" label="Start time" @input="OnHolidayStartTimeInput"></time-picker-dialog>
					</v-col>
					<v-col cols="1"
						><v-list-item-title align="center" justify="center" class="text-wrap"><h2>-</h2></v-list-item-title></v-col
					>
					<v-col>
						<time-picker-dialog initial="13:00" label="End time" @input="OnHolidayEndTimeInput"></time-picker-dialog>
					</v-col>
				</v-row>

				<v-row
					><v-col>
						<v-list-item-title class="pt-5 text-center text-wrap"
							><h2>{{ getLabel('opsSystemsHeading', 'Systems used') }}</h2></v-list-item-title
						>
					</v-col></v-row
				>

				<v-row
					><v-col class="pb-0" cols="12">
						<v-text-field
							v-model="systemsUsed"
							:label="getLabel('companyOperationsSectionSystemsUsed', 'Tell us about any specific software/programs that your Locum needs to work with')"
							outlined
							class="ops-systems-field"
						></v-text-field> </v-col
				></v-row>

				<v-row align="center" justify="center">
					<v-col align="center" justify="center" cols="12" md="7">
						<DistinctYesNo :initial="professionalInsuranceCover" @input="changeInsuranceCover">{{
							getLabel('companyOperationsSectionInsuranceQuestion', 'Does your Malpractice Insurance cover Locums working in your practice?')
						}}</DistinctYesNo>
					</v-col>
				</v-row>

				<v-row
					><v-col cols="12">
						<v-select
							v-model="languagesPreferred"
							label="Enter the preferred languages"
							outlined
							multiple
							chips
							:items="languagesOptions"
							:rules="languagesPreferredRules"
						></v-select> </v-col
				></v-row>
			</v-card-text>
		</v-form>
	</v-container>
</div>
